module.exports = __webpack_public_path__ + "static/001-7c2975bf80826c1cbd9820e3adff1989.png";